import { create } from "zustand";
import type { PriceLevel } from "../map/levels";

/** What the user last clicked on the map. */
export interface Selection {
  /** Which geography the click resolved to. */
  scope: PriceLevel;
  code: string;
  name: string;
  /** Codes of the containing areas, for the breadcrumb. */
  parents?: { level: PriceLevel; code: string; name: string }[];
  /** Everything the tile carried for this feature, including p2021…p2025. */
  properties: Record<string, unknown>;
  /** Exactly where the user clicked — what "nearby" is measured from. */
  point: { lon: number; lat: number };
  /**
   * Environment readings sampled from the tiles already under the cursor.
   * Read at click time because the data is in the browser's hands anyway —
   * asking the server for it would be a round-trip for nothing.
   */
  green?: { score: number; greenPct: number; parkM: number };
  /** Air and noise class, 1–3 (WHO-compliant → above EU limits). */
  airNoise?: { air: number; noise: number };
  /**
   * The address the user searched for, when they got here by searching rather
   * than by clicking. A shortlist of flats wants street addresses, not the
   * name of the surrounding statistical zone.
   */
  address?: string;
}

interface SelectionState {
  selection: Selection | null;
  select: (s: Selection | null) => void;
}

export const useSelectionStore = create<SelectionState>((set) => ({
  selection: null,
  select: (selection) => set({ selection }),
}));
